import logo from './logo.svg';
import './App.css';
import ThreeLink from './components/link-three/three';

function App() {
  return (
    <ThreeLink />
  );
}

export default App;
